import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { SignIn, SignUp } from "@clerk/react";
import { Toaster } from "@/components/ui/sonner";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { Layout } from "@/components/site/Layout";
import { Preloader } from "@/components/site/Preloader";
import Home from "@/pages/Home";
import Book from "@/pages/Book";
import FunZone from "@/pages/FunZone";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import MyAppointments from "@/pages/MyAppointments";
import AskSparkle from "@/pages/AskSparkle";
import { ServicesPage, AboutPage, ReviewsPage, FaqPage, ContactPage } from "@/pages/SitePages";
import Admin from "@/pages/admin/Admin";

const AuthPage = ({ children }) => (
  <div className="flex min-h-[70vh] items-center justify-center px-4 py-16 dot-bg">{children}</div>
);

function App() {
  useEffect(() => { document.title = "Tooth Buds | Pediatric Dentist in Malad West, Mumbai"; }, []);
  return (
    <BrowserRouter>
      <Preloader />
      <ClerkAuthProvider>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/book" element={<Book />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/reviews" element={<ReviewsPage />} />
            <Route path="/faq" element={<FaqPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/ask" element={<AskSparkle />} />
            <Route path="/fun-zone" element={<FunZone />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/my-appointments" element={<MyAppointments />} />
            <Route path="/sign-in/*" element={<AuthPage><SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp /></AuthPage>} />
            <Route path="/sign-up/*" element={<AuthPage><SignUp routing="path" path="/sign-up" signInUrl="/sign-in" /></AuthPage>} />
          </Route>
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </ClerkAuthProvider>
      <Toaster richColors position="top-center" />
    </BrowserRouter>
  );
}

export default App;
